import React, { useEffect, useState, useMemo } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import PropTypes from "prop-types";

import * as brandActions from "src/redux/actions/brand.action";
import * as departmentActions from "src/redux/actions/department.action";
import * as yearActions from "src/redux/actions/year.action";
import * as reportfinalbydeptsActions from "src/redux/actions/reportfinalbydepts.action";
import * as budgetsActions from "src/redux/actions/budgets.action";
import * as approvebudgetActions from "src/redux/actions/approvebudget.action";
import * as updateapprovebudgetActions from "src/redux/actions/updateapprovebudget.action";
import * as rejectapprovebudgetActions from "src/redux/actions/rejectapprovebudget.action";
import * as approvebudgethistoryActions from "src/redux/actions/approvebudgethistory.action";
import * as reportbudgetdetailActions from "src/redux/actions/reportbudgetdetail.action";

import { useParams } from "react-router-dom";
import {
  AppBar,
  Tabs,
  Tab,
  TextField,
  Grid,
  Typography,
  makeStyles,
  Button,
  Icon,
  Modal,
  Backdrop,
  Fade,
  Card,
  CardActions,
  CardContent,
  MenuItem,
  Paper,
  Box,
  ButtonGroup,
  Container,
  CardHeader,
  Divider,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
// import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Formik, Form, Field } from "formik";

import { TextField as TextFieldFormik } from "formik-material-ui";
// import budgetssidReducer from "../../reducers/budgetssid.reducer";
import CustomDialog from "src/components/fragments/CustomDialog";
import PopupDialog from "src/components/fragments/PopupDialog";
import Page from "src/components/Page";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  iconbtnreject: {
    color: "secondary",
  },
}));

export default function ManagerReportDetailByBrand() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [brandId, setBrandId] = useState(0);
  const [deptId, setDeptId] = useState(0);
  const [yearId, setYearId] = useState(0);
  const [yearCode, setyearCode] = useState(0);
  const [yearLock, setYearLock] = useState(null);
  const [budgetsid, setBudgetsid] = useState(null);
  const [openPopupDlg, setOpenPopupDlg] = useState(false);
  const [openPopupDlgWarn, setOpenPopupDlgWarn] = useState(false);

  const [openDlgconfirm, setopenDlgconfirm] = useState(false);

  const yearReducer = useSelector(({ yearReducer }) => yearReducer);
  const budgetsReducer = useSelector(
    ({ budgetsReducer }) => budgetsReducer,
    shallowEqual
  );
  const brandReducer = useSelector(({ brandReducer }) => brandReducer);
  const departmentReducer = useSelector((state) => state.departmentReducer);
  const loginReducer = useSelector((state) => state.loginReducer);
  const reportfinalbydeptsReducer = useSelector(
    (state) => state.reportfinalbydeptsReducer
  );
  const reportbudgetdetailReducer = useSelector(
    (state) => state.reportbudgetdetailReducer
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const clearDataDropDown = () => {
    // dispatch(reportfinalbydeptsActions.clearreportFianlByDepts());

    dispatch(
      departmentActions.getDepts(loginReducer.result.countryid, 0, 0, 0)
    );
    setValue(0);

    dispatch(reportbudgetdetailActions.clearreportBudgetsDetail());
  };

  const handleChangeBrand = (e) => {
    const data = e.target.value;
    clearDataDropDown();
    // setValue(0);
    // dispatch(reportbudgetdetailActions.clearreportBudgetsDetail());
    setBrandId(data);
  };

  const renderDepts = (e) => {
    dispatch(
      departmentActions.getDepts(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid,
        brandId
      )
    )
      .then((result) => {
        setTimeout(() => {
          if (result) {
          } else {
          }
        }, 1000);
      })
      .catch((result) => {});
  };

  const handleChangeYear = (e) => {
    const { BUDGETH_ID, YEAR_CODE, BUDGETH_LOCK } = JSON.parse(e.target.value);
    clearDataDropDown();
    // setValue(0);
    if (BUDGETH_ID !== undefined) {
      setYearId(BUDGETH_ID);
    } else {
      setYearId(0);
    }
    // renderDepts();
    setyearCode(YEAR_CODE);
    setYearLock(BUDGETH_LOCK);
  };

  // const handleConfirmDlg = (value, data) => {
  //   if (value) {
  //     dispatch(reportfinalbybrandActions.reportFinalByBrand(data));
  //     setOpenPopupDlg(true);
  //   }
  //   setopenDlgconfirm(false);
  // };

  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch(
        brandActions.getBrands(
          loginReducer.result.countryid,
          loginReducer.result.companyid,
          loginReducer.result.secureid
        )
      );
      dispatch(
        yearActions.getYear(
          loginReducer.result.countryid +
            loginReducer.result.companyid +
            brandId +
            yearId
        )
      );

      return () => {
        clearDataDropDown();
        dispatch(reportbudgetdetailActions.clearreportBudgetsDetail());
      };
    },
    []
    // [countryid, companyid, brandId, deptId, yearId]
  );
  return (
    // <Alert icon={false} variant="outlined" severity="error">
    //   <Typography variant="h4">Report Budget Detail</Typography>
    // </Alert>
    <Page className={classes.root} title="Report Budget Detail">
      <Container maxWidth={false}>
        <Card>
          <CardHeader subheader="For Report Budget Detail" title="Report Budget Detail" />
          <Divider />
          <CardContent>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                renderDepts();
              }}
            >
              <Grid container xs={12}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  flex={1}
                  style={{ lineHeight: 5 }}
                >
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeBrand}
                    id="brand"
                    label="Brand"
                    // autoComplete="investmenttype"
                    autoFocus
                    style={{ width: "20%", minWidth: "10%" }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={0}
                  >
                    <option key={0} value={0} selected>
                      -
                    </option>
                    {brandReducer.result &&
                      brandReducer.result.map((item) => (
                        <option
                          key={item.ORG_BRAND_ID}
                          value={item.ORG_BRAND_ID}
                        >
                          {item.BRAND}
                        </option>
                      ))}
                  </TextField>

                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    select
                    onChange={handleChangeYear}
                    label="Year"
                    style={{ width: "10%", marginLeft: 10 }}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={0}
                  >
                    <option key={0} value={0} selected>
                      -
                    </option>
                    {yearReducer.result &&
                      yearReducer.result.map((item) => (
                        // <MenuItem value={item}>{item.YEAR_CODE}</MenuItem>
                        <option
                          key={item.YEAR_CODE}
                          value={JSON.stringify(item)}
                        >
                          {/* {item.YEAR_CODE} */}
                          {item.YEAR_SEQ_T}
                        </option>
                      ))}
                  </TextField>

                  <Box style={{ marginLeft: 10 }}>
                    <Button
                      // variant="outlined"
                      variant="contained"
                      color="default"
                      type="submit"
                    >
                      <Icon>search</Icon> Search
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </form>
            <br />
            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant="fullWidth"
                centered
              >
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="-  Choose Department  -"
                  {...a11yProps(0)}
                />
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="Report Budget for Export"
                  {...a11yProps(1)}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <Grid container spacing={2}>
                <Paper className={classes.root}>
                  <MaterialTable
                    title="Report by Department"
                    isLoading={departmentReducer.isFetching}
                    on
                    columns={[
                      {
                        title: "ORG_CODE",
                        field: "ORG_DEPARTMENT_ID",
                        hidden: true,
                      },
                      {
                        title: "Code",
                        field: "DEPARTMENT_CODE",
                        width: 80,
                      },
                      {
                        title: "Group",
                        field: "DEPARTMENT_GROUP",
                        width: 80,
                      },
                      {
                        title: "Department",
                        field: "department",
                      },
                    ]}
                    data={
                      departmentReducer.result ? departmentReducer.result : []
                    }
                    actions={[
                      {
                        tooltip: "Process report data",
                        icon: "table_chart",
                        iconProps: {
                          style: {
                            fontSize: "50px",
                            color: "#5c9aff",
                            captionSide: "bottom",
                          },
                        },
                        onClick: (e, rowData) => {
                          if (brandId !== 0 && yearId !== 0) {
                            let data = {};
                            data.department = rowData;
                            data.input = {
                              COUNTRYID: loginReducer.result.countryid,
                              COMPANYID: loginReducer.result.companyid,
                              BRANDID: brandId,
                              HID: yearId,
                              SECID: loginReducer.result.secureid,
                            };

                            dispatch(
                              reportbudgetdetailActions.reportBudgetsDetail(
                                data
                              )
                            );
                            setValue(1);
                            // setOpenPopupDlg(true);
                          } else {
                            // setOpenPopupDlgWarn(true);
                          }
                        },
                      },
                    ]}
                    options={{
                      selection: true,
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      showTitle: false,
                      searchFieldAlignment: "left",
                      // toolbarButtonAlignment: "left",
                      pageSize: 10,
                      pageSizeOptions: [10, 50, 100],
                      paging: true,
                    }}
                  />
                </Paper>
              </Grid>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <MaterialTable
                    title="Report Budget Detail"
                    on
                    isLoading={reportbudgetdetailReducer.isFetching}
                    data={
                      reportbudgetdetailReducer.result
                        ? reportbudgetdetailReducer.result
                        : []
                    }
                    columns={[
                      { title: "Department Code", field: "DEPARTMENT_CODE" },
                      { title: "Department Name", field: "DEPARTMENT_NAME" },
                      { title: "Type.", field: "ACC_CAT" },
                      { title: "Project Code", field: "PROJECT_CODE" },
                      { title: "Group.", field: "ACC_GROUP2" },
                      { title: "Code.", field: "ACC_CODE" },
                      { title: "Name", field: "ACC_NAME" },
                      { title: "Type", field: "ACC_TYPE_NM" },
                      {
                        title: "Total Budget",
                        field: "TOTAL_BUDGET",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.TOTAL_BUDGET) {
                            return rowData.TOTAL_BUDGET.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Jan.",
                        field: "V_BUDGETSD_M1",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M1) {
                            return rowData.V_BUDGETSD_M1.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Feb.",
                        field: "V_BUDGETSD_M2",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M2) {
                            return rowData.V_BUDGETSD_M2.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Mar.",
                        field: "V_BUDGETSD_M3",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M3) {
                            return rowData.V_BUDGETSD_M3.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Apr.",
                        field: "V_BUDGETSD_M4",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M4) {
                            return rowData.V_BUDGETSD_M4.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "May",
                        field: "V_BUDGETSD_M5",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M5) {
                            return rowData.V_BUDGETSD_M5.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Jun.",
                        field: "V_BUDGETSD_M6",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M6) {
                            return rowData.V_BUDGETSD_M6.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Jul.",
                        field: "V_BUDGETSD_M7",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M7) {
                            return rowData.V_BUDGETSD_M7.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Aug.",
                        field: "V_BUDGETSD_M8",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M8) {
                            return rowData.V_BUDGETSD_M8.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Sep.",
                        field: "V_BUDGETSD_M9",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M9) {
                            return rowData.V_BUDGETSD_M9.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Oct.",
                        field: "V_BUDGETSD_M10",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M10) {
                            return rowData.V_BUDGETSD_M10.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Nov.",
                        field: "V_BUDGETSD_M11",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M11) {
                            return rowData.V_BUDGETSD_M11.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Dec.",
                        field: "V_BUDGETSD_M12",
                        type: "numeric",
                        render: (rowData) => {
                          if (rowData.V_BUDGETSD_M12) {
                            return rowData.V_BUDGETSD_M12.toFixed(2).replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            );
                          } else {
                            return "0.00";
                          }
                        },
                      },
                      {
                        title: "Detail",
                        field: "ACCDETAIL",
                        type: "string",
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      },
                    ]}
                    options={{
                      headerStyle: {
                        backgroundColor: "#5c9aff",
                      },
                      rowStyle: {
                        backgroundColor: "#edf4ff",
                      },
                      showTitle: false,
                      searchFieldAlignment: "left",
                      exportButton: true,
                      toolbarButtonAlignment: "left",
                      exportAllData: true,
                      // actionsColumnIndex: -1,
                      pageSize: 10,
                      pageSizeOptions: [10, 50, 100],
                      // paging: true,
                    }}
                  />
                </Grid>
              </Grid>
              <br />
            </TabPanel>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
